// Tenantra logo — roofline + T monogram, inline SVG (no tile/sticker)
export const LogoMark = ({ className = 'w-8 h-8', color = '#0F766E' }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
    <path d="M3 15.5 L16 4 L29 15.5" stroke={color} strokeWidth="3.2" strokeLinecap="square" strokeLinejoin="miter" />
    <path d="M8 17 H24 V20.5 H17.75 V29 H14.25 V20.5 H8 Z" fill={color} />
  </svg>
);

export const Logo = ({ size = 'md', dark = false, className = '', ...rest }) => {
  const dims = { sm: ['w-7 h-7', 'text-[17px]'], md: ['w-8 h-8', 'text-lg'], lg: ['w-9 h-9', 'text-xl'] }[size];
  return (
    <a href="/" className={`inline-flex items-center gap-2 ${className}`} aria-label="Tenantra home" {...rest}>
      <LogoMark className={dims[0]} color={dark ? '#5EEAD4' : '#0F766E'} />
      <span className={`font-bold tracking-tight ${dims[1]} ${dark ? 'text-white' : 'text-stone-900'}`} style={{ fontFamily: "'Chivo', sans-serif" }}>Tenantra</span>
    </a>
  );
};
